import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/bank-accounts'

class BankRoutingService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  async getAll (params = {}) {
    const result = await this._apiConsume.getData(BASE_URL, { params })
    return result?.data
  }

  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  async getChannels () {
    const result = await this._apiConsume.getData(`${BASE_URL}/channels`)
    return result?.data
  }

  async getPaymentVendors () {
    const result = await this._apiConsume.getData('/api/dashboard/payment-vendors')
    return result?.data
  }

  async create (payload) {
    const result = await this._apiConsume.postData(payload, BASE_URL)
    return result?.data
  }

  async update (id, payload) {
    const result = await this._apiConsume.putData(payload, `${BASE_URL}/${id}`)
    return result?.data
  }

  async toggle (id, enabled) {
    const result = await this._apiConsume.patchData({ enabled }, `${BASE_URL}/${id}/toggle`)
    return result?.data
  }

  async remove (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }
}

export default BankRoutingService
